import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';
import { EbsWebServiceGlobals } from "../../services/ebsWebServiceGlobals";

@Component({
  selector: 'page-iframe',
  templateUrl: 'iframe.html',
  providers: [EbsWebServiceGlobals]
})
export class IFrame {

  actionURL: any;
  iframeURL: any;
  title: any;
  isDownload: any = false;
  showIframe: any = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private sanitizer: DomSanitizer,
    public events: Events,
    private ebsWebServiceGlobals: EbsWebServiceGlobals) {

    this.title = this.navParams.get('title');
    this.actionURL = this.navParams.get('actionURL');
    this.iframeURL = this.ebsWebServiceGlobals.getIframeURL() + this.actionURL;

    //events.publish("reloadMenu");

    this.checkDownload();
  }

  checkDownload() {
    if (this.iframeURL.indexOf("DownloadFile") >= 0) {
      if (this.isDownload) {

        console.log("download: " + this.iframeURL);
        this.isDownload = true;
        this.showIframe = false;
        window.location.href = this.iframeURL;
        this.navCtrl.pop();
      } else {
        this.isDownload = false;
        this.showIframe = true;
        this.iframeURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeURL);
      }
    } else {
      this.showIframe = true;
      this.isDownload = false;
      this.iframeURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeURL);
    }
  }

  //getIframeURL() {
  //  if (this.iframeURL.indexOf("DownloadFile") >= 0) {
  //    if (this.isDownload) {
  //
  //      console.log("download: " + this.iframeURL);
  //      this.isDownload = false;
  //      window.location.href = this.iframeURL;
  //      this.navCtrl.pop();
  //    }
  //    return;
  //  } else {
  //    this.showIframe = true;
  //    console.log("iframe");
  //    return this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeURL);
  //  }
  //}
}



// WEBPACK FOOTER //
// ./src/pages/iframe/iframe.ts